import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { plannerStore } from "../../App";

const Header = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const setIsInStart = plannerStore((state) => state.setIsInStart);
  const handleNavClick = (path) => {
    navigate(path);
    setMenuOpen(false);
    setDropdownOpen(false);
  };

  return (
    <nav className="w-full bg-gray-100 shadow-md fixed top-0 left-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-12 items-center">
          <div
            className="md:text-sm sm:text-sm lg:text-lg font-semibold text-black cursor-pointer"
            onClick={() => {
              navigate("/");
              setIsInStart(false);
            }}
          >
            Plan your way
          </div>

          {/* Desktop Menu */}
          <div className="hidden sm:flex space-x-6 items-center">
            <div className="relative">
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="text-gray-700 hover:text-gray-900 font-medium"
              >
                Planner Pages ▾
              </button>
              {dropdownOpen && (
                <div className="absolute mt-2 w-48 bg-white shadow-lg rounded-lg border">
                  <button
                    onClick={() => handleNavClick("/template")}
                    className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
                  >
                    Template Selection
                  </button>
                  <button
                    onClick={() => handleNavClick("/colorSelection")}
                    className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
                  >
                    Color Selection
                  </button>
                  <button
                    onClick={() => handleNavClick("/font")}
                    className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
                  >
                    Font Selection
                  </button>
                </div>
              )}
            </div>

            <button
              onClick={() => handleNavClick("/login")}
              className="text-gray-700 hover:text-gray-900 font-medium"
            >
              Owner Login
            </button>
          </div>

          <div className="sm:hidden">
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="text-gray-700 focus:outline-none"
            >
              {menuOpen ? "✕" : "☰"}
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="sm:hidden bg-gray-50 border-t border-gray-200">
          <button
            onClick={() => setDropdownOpen(!dropdownOpen)}
            onex={() => setDropdownOpen(false)}
            className="block w-full text-left px-4 py-2 text-gray-700 font-medium"
          >
            Planner Pages ▾
          </button>
          {dropdownOpen && (
            <div className="pl-4">
              <button
                onClick={() => handleNavClick("/template")}
                className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
              >
                Template Selection
              </button>
              <button
                onClick={() => handleNavClick("/colorSelection")}
                className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
              >
                Color Selection
              </button>
              <button
                onClick={() => handleNavClick("/font")}
                className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
              >
                Font Selection
              </button>
            </div>
          )}
          <button
            onClick={() => handleNavClick("/login")}
            className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
          >
            Owner Login
          </button>
        </div>
      )}
    </nav>
  );
};

export default Header;
